import { render, staticRenderFns } from "./TgCjInterview.vue?vue&type=template&id=5cc73ba0&"
import script from "./TgCjInterview.vue?vue&type=script&lang=js&"
export * from "./TgCjInterview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports